export function getImageDimensions(file) {
  return new Promise(function (resolve) {
    var i = new Image()
    i.onload = function () {
      resolve({ width: i.width, height: i.height })
    }
    i.src = file
  })
}
